module.exports = __webpack_public_path__ + "static/pratya-8790b1a52560aa628913461003e48ed6.png";